import React__default, { useState } from 'react';
import { Icon } from '../../display/Icon/Icon.es.js';
import { FormLabel } from '../FormLabel/FormLabel.es.js';
import { useOverflow } from '../../../hooks/useOverflow.es.js';
import { uniqueId } from '../../../utils/uniqueId.es.js';

const field = "_field_js25v_1";
const helpTextWrapper = "_help-text-wrapper_js25v_6";
const helpText = "_help-text_js25v_6";
const helpTextInner = "_help-text-inner_js25v_21";
const helpTextToggle = "_help-text-toggle_js25v_32";
const error = "_error_js25v_53";
const styles = {
	field: field,
	helpTextWrapper: helpTextWrapper,
	helpText: helpText,
	helpTextInner: helpTextInner,
	helpTextToggle: helpTextToggle,
	error: error
};

const HelpText = ({ children, helpTextLineClamp }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOverflowing, setOverflowingNode] = useOverflow();
  const toggle = isOverflowing && React__default.createElement("button", { "aria-hidden": "true", className: styles.helpTextToggle, onClick: () => setIsOpen(!isOpen), type: "button", "data-zds": true }, isOpen ? "Less" : "More");
  const style = {
    WebkitLineClamp: isOpen ? void 0 : helpTextLineClamp
  };
  return React__default.createElement(
    "div",
    { className: styles.helpText, "data-zds": true },
    React__default.createElement(
      "div",
      { className: styles.helpTextInner, ref: (node) => setOverflowingNode(node), "data-zds": true, style },
      React__default.createElement("div", { "data-zds": true }, children)
    ),
    toggle
  );
};
const Field = ({ label, renderInput, error = void 0, inputId = void 0, isCompact = false, isDisabled = void 0, isRequired = void 0, helpTextLineClamp = 1, renderHelpText = void 0, renderLabel = void 0, requiredText = void 0 }) => {
  const [id] = useState(inputId || uniqueId("Field-"));
  const describedById = `${id}-description`;
  const helpText = renderHelpText && renderHelpText();
  return React__default.createElement(
    "div",
    { className: styles.field, "data-zds": true },
    React__default.createElement("div", { "data-zds": true }, renderLabel ? renderLabel({
      htmlFor: id,
      isDisabled,
      isErrored: !!error,
      isRequired,
      label,
      requiredText
    }) : React__default.createElement(
      FormLabel,
      { alignItems: "start", htmlFor: id, isDisabled, isErrored: !!error, isRequired, requiredText, size: isCompact ? "compact" : "small" },
      error && React__default.createElement(Icon, { color: "StatusErrorStronger", isBlock: true, name: "formXCircle", size: 18 }),
      React__default.createElement("span", { "data-zds": true }, label)
    )),
    React__default.createElement("div", { "data-zds": true }, renderInput({
      ariaDescribedBy: helpText || error ? describedById : void 0,
      id,
      isDisabled: !!isDisabled,
      isErrored: !!error,
      isRequired: !!isRequired
    })),
    React__default.createElement("div", { "aria-live": error ? "polite" : "off", className: styles.helpTextWrapper, "data-compact": isCompact, id: describedById, "data-zds": true }, (helpText || error) && React__default.createElement(
      HelpText,
      { helpTextLineClamp },
      error && React__default.createElement("span", { className: styles.error }, error),
      error && helpText && " ",
      helpText
    ))
  );
};

export { Field };
//# sourceMappingURL=Field.es.js.map
